'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/object-is/polyfill.js
// module id = 307
// module chunks = 0 15 16 17 18